import { cx } from "./ui";

export type StatusTone = "success" | "neutral" | "warning" | "danger" | "info";
const CHIP: Record<StatusTone, string> = {
  success: "bg-hs-success-soft text-hs-success", warning: "bg-hs-warning-soft text-hs-warning", danger: "bg-hs-danger-soft text-hs-danger",
  info: "bg-hs-info-soft text-hs-info", neutral: "bg-hs-chip text-hs-text-muted",
};

/**
 * A soft-filled status chip (the Figma's "On"): a word on a tinted 4px-radius box, for on/off/paused/removing,
 * mode and job status. `wrap` is for sentence-length labels (health alerts, "Paused by …"): the text wraps.
 */
export function StatusDot({ tone, label, detail, wrap }: { tone: StatusTone; label: string; detail?: string; wrap?: boolean }) {
  return (
    <span className={cx("inline-flex min-w-[3.5rem] items-center justify-center rounded px-2 py-1 text-sm font-medium", CHIP[tone], wrap ? "text-left" : "whitespace-nowrap")}>
      <span className={cx(wrap && "min-w-0")}>{label}{detail && <span className="opacity-70"> · {detail}</span>}</span>
    </span>
  );
}
